import { render, staticRenderFns } from "./QuillInput.vue?vue&type=template&id=6b0b5389"
import script from "./QuillInput.vue?vue&type=script&lang=js"
export * from "./QuillInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports